import { GiveawayContributionApiClient } from '@fourthwall/services/dist/GiveawayContributionApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useGiveawayGiftsQuery = createQueryHook(
  GiveawayContributionApiClient.getGiveawayGifts,
  {
    queryKey: ['giveawayGifts'],
  },
)
